import React, { Component, PropTypes } from 'react'

function FullScreen({ children }) {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',

                position: 'fixed',
                top: 0,
                left: 0,
                height: '100vh',
                width: '100vw',
            }}
        >
            <div style={{ padding: 48 }}>
                { children }
            </div>
        </div>
    )
}
FullScreen.propTypes = {
    children: PropTypes.node,
}

export default class AuthWrapper extends Component {
    static displayName = 'AuthWrapper'

    static propTypes = {
        account: PropTypes.shape({
            user: PropTypes.object,
            network_error: PropTypes.bool.isRequired,
        }).isRequired,
        actions: PropTypes.shape({
            authenticate: PropTypes.func.isRequired,
        }).isRequired,
        children: PropTypes.node,
    }

    componentWillMount() {
        if (! this.props.account.user) {
            this.props.actions.authenticate()
        }
    }

    render() {
        // If the redux store thinks there's a network error, display a fullscreen banner stating
        // such.
        if (this.props.account.network_error === true) {
            return (
                <FullScreen>
                    <h1>Network error</h1>

                    <p>
                        Sorry there is a network error. Please ensure that you are connected to the
                        internet and refresh your browser to try again.
                    </p>
                </FullScreen>
            )
        }

        // If we have an authenticated user, show the app's content
        if (this.props.account.user) {
            return (
                <div>
                    { this.props.children }
                </div>
            )
        }

        // If we don't have a user yet, show the "authenticating" loading screen
        return (
            <FullScreen>
                <div className="text-center">
                    <i className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                    <br />
                    <br />
                    Authenticating, please wait...
                </div>
            </FullScreen>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/account/auth_wrapper.js